import { useState, useEffect, useLayoutEffect } from 'react'

const useIsomorphicLayoutEffect = typeof window !== 'undefined' 
  ? useLayoutEffect 
  : useEffect;

const useMedia = (breakpoints, values, defaultValue = null) => {
  const isWindow = typeof window === 'object'

  const [breakValue, setBreakValue] = useState(defaultValue)

  const useEffectHandler = () => {
    if (!isWindow) {
      return
    }
    const mediaQueryList = breakpoints.map((q) => matchMedia(q))

    const currentBreakpoint = () => setBreakValue(() => {
      const index = mediaQueryList.findIndex((mql) => mql.matches)

      return typeof values[index] !== 'undefined' ? values[index] : defaultValue 
    })

    mediaQueryList.forEach((mq) => {
      currentBreakpoint();

      mq.addEventListener('change', currentBreakpoint,{passive: true })
    })

    return () => mediaQueryList.forEach((mq) => mq.removeEventListener('change', currentBreakpoint))
  }

  useIsomorphicLayoutEffect(useEffectHandler, [isWindow])

  return breakValue;
}

export default useMedia;